import React from 'react';

import SpecPagesView from 'components/SpecialPages/SpecPagesView';

const SpecialPagesListL = props => (
  <div id="content">
    <SpecPagesView {...props} />
  </div>
);

export default SpecialPagesListL;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/SpecPages/SpecialPagesView/SpecialPagesView.js